import { IconOptions } from 'primereact/utils';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const RequestedCertificateIcon = (options: IconOptions) => {
  return (
    <svg width='24' height='24' viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg' {...options}>
      <g transform='translate(0,64) scale(0.1,-0.1)' fill='currentColor' stroke='none'>
        <path d='M267 542 c-26 -26 -47 -51 -47 -55 0 -16 26 -5 57 25 l33 32 0 -127 c0 -78 4 -127 10 -127 6 0 10 49 10 127 l0 127 33 -32 c31 -30 57 -41 57 -24 0 8 -92 102 -101 102 -2 0 -26 -22 -52 -48z' />
        <path d='M86 366 c-45 -83 -46 -85 -46 -178 0 -99 3 -109 37 -127 30 -15 456 -15 486 0 34 18 37 28 37 126 0 87 -2 98 -39 178 l-40 85 -41 0 c-49 0 -51 -23 -3 -28 27 -3 34 -10 57 -63 14 -33 26 -62 26 -65 0 -2 -18 -4 -41 -4 -48 0 -73 -12 -115 -56 -28 -30 -37 -34 -84 -34 -47 0 -56 4 -84 34 -42 44 -67 56 -116 56 -23 0 -40 3 -38 8 44 93 64 121 87 124 40 5 38 28 -2 28 -34 0 -37 -3 -81 -84z m121 -146 l36 -40 77 0 77 0 36 40 c33 37 40 40 87 40 l51 0 -3 -87 -3 -88 -245 0 -245 0 -3 88 -3 87 51 0 c47 0 54 -3 87 -40z' />
      </g>
    </svg>
  );
};

export default RequestedCertificateIcon;
